'use client';

import { Suspense } from 'react';
import { usePathname } from 'next/navigation';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { CSRFProvider } from '../../contexts/csrf-context';
import { AuthProvider } from '@/contexts/AuthContext';
import Header from './Header';
import { NextIntlClientProvider } from 'next-intl';
import { PostHogProvider } from '../providers/PHProvider';
import ReactQueryProvider from '../providers/ReactQueryProvider';
import { LoadingProvider } from '../ui/LoadingProvider';
import ErrorBoundary from '../ErrorBoundary';

export default function ClientLayoutWrapper({ children, locale, messages }) {
  const pathname = usePathname();
  const isTarotPage = pathname.startsWith('/tarot-cards/');
  const isChatInterfacePage = pathname.includes('/chatinterface');

  return (
    <NuqsAdapter>
      <NextIntlClientProvider locale={locale} messages={messages}>
        <ErrorBoundary level="page" featureName="client-layout">
          <CSRFProvider>
            <AuthProvider>
              <PostHogProvider>
                <ReactQueryProvider>
                  <LoadingProvider>
                    {!isTarotPage && !isChatInterfacePage && <Header session={null} />}
                    <div className={isTarotPage || isChatInterfacePage ? '' : 'pt-20'}>
                      <ErrorBoundary level="feature" featureName="main-content">
                        {children}
                      </ErrorBoundary>
                    </div>
                  </LoadingProvider>
                </ReactQueryProvider>
              </PostHogProvider>
            </AuthProvider>
          </CSRFProvider>
        </ErrorBoundary>
      </NextIntlClientProvider>
    </NuqsAdapter>
  );
}

